import React from 'react';
import { Alert, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useTranslation } from 'react-i18next';

/**
 * Persistent banner shown when a screen is under the invoice-ahead freeze
 */
const FreezeBanner = ({ sx }) => {
    const { t } = useTranslation();
    return (
        <Alert
            severity="warning"
            icon={<InfoOutlinedIcon fontSize="inherit" />}
            sx={{ borderRadius: '5px', margin: '10px 0', ...sx }}
        >
            <Typography variant="body1">
                <strong>{t('freeze.bannerTitle')}</strong>
                <br />
                {t('freeze.bannerMessage')}
            </Typography>
        </Alert>
    );
};

export default FreezeBanner;
